<template>
  <list title="Campaign Applications" product-type="campaign" />
</template>

<script>
import List from './List.vue';

export default {
  components: { List },
};
</script>
